const serve_route = [
  {
    path: '/serve',
    name: "serve",
    component: resolve => {
      require(["@/views/manage/serve/Index.vue"], resolve);
    },
    redirect: { path: "/serve/servelist" },
    meta: {
      public: false,
      title: '服务管理',
      navtype: 1,
      active: ['/serve/servelist','/serve/servechecklist']
    },
    children: [
      {
        path: 'servelist',
        name: "servelist",
        component: resolve => {
          require(["@/views/manage/serve/serveManage/ServeList.vue"], resolve);
        },
        meta: {
          public: false,
          title: '服务列表',
          navtype: 1,
          id:[10037],
          active: ['/serve/servelist','/serve/servechecklist']
        }
      },
      {
        path: 'serveinfo',
        name: "serveinfo",
        component: resolve => {
          require(["@/views/manage/serve/serveManage/ServeInfo.vue"], resolve);
        },
        meta: {
          public: false,
          title: '服务详情',
          navtype: 1,
          id:[10038],
          active: ['/serve/servelist','/serve/servechecklist']
        }
      },
      {
        path: 'servechecklistindex',
        name: "servechecklist",
        redirect: "/serve/servechecklist",
        component: resolve => {
          require(["@/views/manage/serve/serveCheck/ServeCheckIndex.vue"], resolve);
        },
        meta: {
          public: false,
          title: '服务上下架审核',
          navtype: 1,
          id:[10039],
          active: ['/serve/servelist','/serve/servechecklist']
        },
        children: [
          {
            path: '/serve/servechecklist',
            name: "servechecklist",
            component: resolve => {
              require(["@/views/manage/serve/serveCheck/ServeCheckList.vue"], resolve);
            },
            meta: {
              public: false,
              // title: '服务上下架审核',
              navtype: 1,
              id:[10039],
              active: ['/serve/servelist','/serve/servechecklist']
            }
          },
          {
            path: '/serve/servecheckinfo',
            name: "servecheckinfo",
            component: resolve => {
              require(["@/views/manage/serve/serveCheck/ServeCheckInfo.vue"], resolve);
            },
            meta: {
              public: false,
              title: '服务详情',
              navtype: 1,
              id:[10040,10041],
              active: ['/serve/servelist','/serve/servechecklist']
            }
          },
        ]
      },
      // {
      //   path: 'servecheckinfo',
      //   name: "servecheckinfo",
      //   component: resolve => {
      //     require(["@/views/manage/serve/serveCheck/ServeCheckInfo.vue"], resolve);
      //   },
      //   meta: {
      //     public: false,
      //     title: '服务详情',
      //     navtype: 1,
      //     id:[10040,10041],
      //     active: ['/serve/servelist','/serve/servechecklist']
      //   }
      // },
    ]
  },
];
export default serve_route